import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { KoreanContainer, KoreanItem } from '../../styles/onBoardStyle';
import Checkbox from './checkbox';

interface MicrositeUsPPProps {
	isFirstChecked: boolean;
	checkFirst: (checked: boolean) => void;
	isScndChecked: boolean;
	checkScnd: (checked: boolean) => void;
	checkboxColor?: string;
}

const MicrositeUsPP = ({ isFirstChecked, checkFirst, isScndChecked, checkScnd, checkboxColor }: MicrositeUsPPProps) => {
	const { t } = useTranslation();

	return (
		<Container>
			<KoreanItem style={{ marginLeft: 'initial' }}>
				<label dangerouslySetInnerHTML={{ __html: t('microsite-us-privacy-notice') }} />
			</KoreanItem>

			<KoreanItem>
				<Checkbox checked={isFirstChecked} onChange={(event) => checkFirst(event.target.checked)} color={checkboxColor} />
				<label dangerouslySetInnerHTML={{ __html: t('microsite-us-privacy-bipa-consent') }} />
			</KoreanItem>

			<KoreanItem>
				<Checkbox checked={isScndChecked} onChange={(event) => checkScnd(event.target.checked)} color={checkboxColor} />
				<label dangerouslySetInnerHTML={{ __html: t('microsite-us-privacy-spi-chd-consent') }} />
			</KoreanItem>
		</Container>
	);
};

const Container = styled(KoreanContainer)`
	padding: 0 0 24px;

	a {
		color: inherit;
		text-decoration: underline;
	}
`;

export default MicrositeUsPP;
